module.exports = __webpack_public_path__ + "static/img/chery_logo.17da15a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_images/chery_logo.png
// module id = or7O
// module chunks = 83